export const ARROW_UP = "ArrowUp";
export const ARROW_DOWN = "ArrowDown";
export const ARROW_LEFT = "ArrowLeft";
export const ARROW_RIGHT = "ArrowRight";
export const ISSUE_ID = "issueID";
export const HAS_INPUT_FIELDS = "hasInputFields";
export const CHANGE_PAGE = "changePage";
export const SHOW_THREE_RULES = "showThreeRules";
export const ACTION_SUBMIT = "actionSubmit";
export const TIMER = "timer";
export const IS_SHOW_TIMER = "isShowTimer";
export const IS_PLAY_VIDEO = "isPlayVideo";
export const IS_SHOW_VIDEO = "isShowVideo";
export const IS_TEACHER_ONLY_ASSESSMENT = "isTeacherOnlyAssessment";
export const IS_STUDENT_ONLY_ASSESSMENT = "isStudentOnlyAssessment";
